import React from "react";
import T from "prop-types";
import {
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES,
  ROLES,
  WAREHOUSE
} from "MODULES/users/constants";
import {
  Authorized,
  EditButton,
  CheckForDetail,
  DetailTable,
  Detail
} from "MODULES/shared/components";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";
import { without } from "lodash";
import EditCustomerRestrictions from "./EditCustomerRestrictions";
import { IMPERFECT_TRACE } from "../../../constants";

export class CustomerRestrictionsTable extends React.Component {
  static propTypes = {
    company: T.instanceOf(Map)
  };

  state = {
    editCustomerRestrictions: false
  };

  toggleModalState = key => {
    const currentValue = this.state[key];
    this.setState({ [key]: !currentValue });
  };

  render() {
    const { editCustomerRestrictions } = this.state;
    const { company } = this.props;

    return (
      <div>
        <h2 style={{ marginTop: 10 }}>
          Customer Restrictions
          <Authorized
            roles={without(ROLES, WAREHOUSE)}
            permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
          >
            <EditButton
              handleClick={() =>
                this.toggleModalState("editCustomerRestrictions")}
            />
            <EditCustomerRestrictions
              company={company.toJS()}
              open={editCustomerRestrictions}
              close={() => this.toggleModalState("editCustomerRestrictions")}
            />
          </Authorized>
        </h2>
        <DetailTable>
          <CheckForDetail
            label="No PMAs Accepted"
            value={company.get("no_pmas_accepted")}
            text=""
          />
          <CheckForDetail
            label="No DERs Accepted"
            value={company.get("no_ders_accepted")}
            text=""
          />
          <Detail
            label="Warranty Minimum"
            value={company.get("warranty_minimum")}
          />
          <Detail
            label="Unaccepted Trace Types"
            value={company
              .get("unaccepted_trace_types")
              .toArray()
              .map(f => INCOMING_LINE_ITEMS.traceTypes[f].label)
              .join(", ")}
          />
          <CheckForDetail
            label="Imperfect Trace Req"
            value={company.get(IMPERFECT_TRACE)}
          />
        </DetailTable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/CustomerRestrictionsTable/CustomerRestrictionsTable.jsx